import { animate, scroll, stagger } from "https://cdn.jsdelivr.net/npm/motion@12.23.6/+esm";

export class MotionLab {
    constructor() {

    }

    init() {
        this.initCategoriesAnimations();
    }

    initCategoriesAnimations() {
        const sectionElement = document.querySelector(".categories-section")
        const sectionContentWrapper = document.querySelector(".categories-section-content")

        if (!sectionElement || !sectionContentWrapper) return;

        const tlPlaceholder = sectionElement.querySelector(".timeline-placeholder")
        const logoWrapper = sectionElement.querySelector(".cs-logo-wrapper")
        const animLogo = logoWrapper.querySelector(".cs-intro-anim-logo")
        const logoParagraph = sectionElement.querySelector(".cs-f-p-wrapper")
        const cityPanoramaImg = sectionElement.querySelector(".cs-city-panorama-img")

        // Sections
        const categoriesLinkingContent = sectionElement.querySelector(".categories-section-linking-content")
        const interior = sectionElement.querySelector(".categories-section-linking-content .categories-section-block.--interior")
        const architecture = sectionElement.querySelector(".categories-section-linking-content .categories-section-block.--architecture")
        const masterplan = sectionElement.querySelector(".categories-section-linking-content .categories-section-block.--masterplan")

        const timelineSeqs = [
            [logoWrapper, { opacity: 1 }, { duration: 5, at: 0 }],
            [logoWrapper.querySelector("figure:not(.--placeholder)"), { opacity: 0 }, { duration: 10, at: ">" }],
            // [logoParagraph.querySelector(".branding-text"), { opacity: [1, 1], x: [0, -100] }, { duration: 5, ease: "ease-in", at: 0 }],
        ]

        if (window.innerWidth >= 768) {
            timelineSeqs.push([logoParagraph.querySelector(".branding-text"), { opacity: [1, 1], x: [0, -100] }, { duration: 5, ease: "ease-in", at: 0 }])
        }

        timelineSeqs.push(
            [categoriesLinkingContent, { x: `-${categoriesLinkingContent.querySelectorAll(".categories-section-block").length}00vw` }, { duration: 100, ease: "linear", at: ">" }],
            [logoParagraph.querySelector(".branding-text"), { opacity: [1, 0], x: window.innerWidth >= 768 ? [-100, -200] : [0, -100] }, { duration: 15, delay: 5, ease: "ease-out", at: "<" }],

            [animLogo, { opacity: 0 }, { duration: 10, at: "<+10" }],

            [cityPanoramaImg.querySelector("img"), { y: ["100%", "0"] }, { duration: 5, ease: [0.86, 0, 0.14, 1], at: 0 }],
            [cityPanoramaImg.querySelector("img"), { x: "calc(-100% + 100vw)" }, { duration: 95, at: ">" }],
            [cityPanoramaImg.querySelector("img"), { y: ["0", "100%"] }, { duration: 5, at: ">" }],

            // [tlPlaceholder, { opacity: 0 }, { duration: 100, at: 0 }],
        )

        const timelineAnims = animate(timelineSeqs, {
            duration: 10,
            repeat: 0,
            direction: "normal",
            fill: "forwards",
            delay: 0,
            easing: "ease-in-out",
        })

        /*
        Architecture Set Animation
        */

        const architectureSet = document.querySelector(".--architecture-set")
        const archBackground = architectureSet.querySelector(".--arch-background")
        const archLayer = architectureSet.querySelector(".--arch-layer")

        const archSeqs = animate([
            [architectureSet, { opacity: 1 }, { duration: window.innerWidth >= 768 ?  20 : 10, at: 0 }],
            [archBackground, { opacity: [0, 1] }, { duration: 5, at: "<" }],
            [archLayer, { y: ["100%", 0] }, { duration: 5, at: ">" }],
            [[archBackground], { opacity: [1, 0] }, {
                duration: 7.5, delay: 30, at: "<"
            }],
            [[archLayer], { y: [0, "100%"] }, {
                duration: 7.5, delay: 30, at: "<"
            }],
            // [document.querySelector(".--architecture-set"), { x: [0, "-100%"] }, { duration: 10, at: ">" }],
        ], {
            duration: 10,
        })

        scroll(archSeqs, {
            target: tlPlaceholder.querySelector(":scope > div:nth-child(2)"),
            offset: ["start center", "end center"],
        })

        /*
        Masterplan Set Animation
        */

        const masterplanSet = document.querySelector(".--masterplan-set")
        const mpBackground = masterplanSet.querySelector(".--masterplan-background")
        const mpLeftBuilding = masterplanSet.querySelector(".--masterplan-left-b")

        const mpSeqs = animate([
            [masterplanSet, { opacity: 1 }, { duration: window.innerWidth >= 768 ?  20 : 10, at: 0 }],
            [mpBackground, { opacity: [0, 1] }, { duration: 5, delay: 5, at: "<" }],
            [mpLeftBuilding, { y: ["100%", 0], opacity: [0, 1] }, { duration: 5, at: "<+3" }],
            [[mpBackground.querySelector("img")], { opacity: [1, 0] }, {
                duration: 7.5, delay: 2.5, at: ">"
            }],
            [mpLeftBuilding, { y: [0, "100%"] }, {
                duration: 7.5, delay: 5, at: "<"
            }],
            // [document.querySelector(".--masterplan-set"), { x: [0, "-100%"] }, { duration: 10, at: ">" }],
        ], {
            duration: 10,
        })

        scroll(mpSeqs, {
            target: tlPlaceholder.querySelector(":scope > div:nth-child(3)"),
            offset: ["start center", "end center"],
        })

        /*
        Interior Set Animation
        */

        const interiorSet = document.querySelector(".--interior-set")
        const intLayer = interiorSet.querySelector(".--interior-layer")
        const intBackground = interiorSet.querySelector(".--interior-background")

        const interiorSeqs = animate([
            [interiorSet, { opacity: 1 }, { duration: window.innerWidth >= 768 ?  20 : 10, at: 0 }],
            [intBackground, { opacity: [0, 1] }, { duration: 5, at: "<" }],
            [intLayer, { y: ["100%", 0] }, { duration: 5, at: "<+0.5" }],
            // [document.querySelector(".--interior-set"), { x: [0, "-100%"] }, { duration: 10, at: ">" }],
        ], {
            duration: 10,
        })

        scroll(interiorSeqs, {
            target: tlPlaceholder.querySelector(":scope > div:nth-child(4)"),
            offset: ["start center", "end center"],
        })

        scroll(timelineAnims, {
            target: sectionElement,
            offset: ["start center", "end end"],
            ease: [0.83, 0, 0.17, 1],
            // once: true,
            // debug: true,
        })
    }
}